import {
  resolveFillRateDifference,
  resolveFillRateCategoryLabel
} from './fillRateMetrics'

export const buildFlatRows = (summary = [], totals = {}) => {
  const rows = []

  summary.forEach(buyerRow => {
    // (BUYER)
    rows.push({
      __type: 'parent',
      buyer: buyerRow.buyer,
      purchase_order_counts: buyerRow.purchase_order_counts,
      purchase_order_total: buyerRow.purchase_order_total,
      order_counts: buyerRow.order_counts,
      order_total: buyerRow.order_total,
      fill_rate_order: buyerRow.fill_rate_order,
      difference: resolveFillRateDifference(buyerRow),
      salesorder_total: buyerRow.salesorder_total,
      fill_rate_sales: buyerRow.fill_rate_sales,
      invoice_total: buyerRow.invoice_total,
      fill_rate_invoice: buyerRow.fill_rate_invoice
    })

    // (CATEGORIES)
    if (buyerRow.children?.length) {
      buyerRow.children.forEach(child => {
        rows.push({
          __type: 'child',
          buyer: '',
          category: resolveFillRateCategoryLabel(child.name),
          purchase_order_total: child.total_oc,
          order_total: child.total_pedido,
          difference: resolveFillRateDifference(child, {
            purchaseOrderKey: 'total_oc',
            orderKey: 'total_pedido'
          }),
          salesorder_total: null,
          invoice_total: null
        })
      })
    }

    // SUBTOTAL
    rows.push({
      __type: 'subtotal',
      buyer: `Subtotal ${buyerRow.buyer}`,
      purchase_order_counts: buyerRow.purchase_order_counts,
      purchase_order_total: buyerRow.purchase_order_total,
      order_counts: buyerRow.order_counts,
      order_total: buyerRow.order_total,
      fill_rate_order: buyerRow.fill_rate_order,
      difference: resolveFillRateDifference(buyerRow),
      salesorder_total: buyerRow.salesorder_total,
      fill_rate_sales: buyerRow.fill_rate_sales,
      invoice_total: buyerRow.invoice_total,
      fill_rate_invoice: buyerRow.fill_rate_invoice
    })
  })

  // GRAND TOTAL
  if (totals) {
    rows.push({
      __type: 'total',
      buyer: 'TOTAL GENERAL',
      purchase_order_counts: totals.purchase_order_counts,
      purchase_order_total: totals.purchase_order_total,
      order_counts: totals.order_counts,
      order_total: totals.order_total,
      fill_rate_order: totals.fill_rate_order,
      difference: totals.difference,
      salesorder_total: totals.salesorder_total,
      fill_rate_sales: totals.fill_rate_sales,
      invoice_total: totals.invoice_total,
      fill_rate_invoice: totals.fill_rate_invoice
    })
  }

  return rows
}
